import { useCallback } from 'react';

import PermissionChip from '@/app/pages/LobbyPage/PermissionChip';
import { CompassPermissionState } from '@/app/hooks/useCompassPermission';

interface CompassPermissionChipProps {
  state: CompassPermissionState;
  request(): Promise<void>;
}

export default function CompassPermissionChip({ state, request }: CompassPermissionChipProps) {
  const onRequestPermission = useCallback(() => {
    request().catch(() => undefined);
  }, [request]);

  return (
    <PermissionChip
      granted={state === 'granted'}
      name="Compass"
      onEnable={onRequestPermission} />
  );
}
